<template>
    <div :class="variant">
        <div class="inner_box"><p><slot></slot></p></div>
    </div>
</template>

<script>
	export default {
		name: "MessageBox",
        props: {
			variant: {
				type: String,
                default: 'info'
            }
        }
	}
</script>


// WEBPACK FOOTER //
// src/components/common/MessageBox.vue